/* eslint-disable */
export default {
    invitation: "Invitation",
    inbox_invitation_description_text: "Si vous cliquez sur « Vers l'aperçu », vous accédez au programme. Chaque section du programme comporte des consignes et une indication de temps. Vous pouvez faire une pause entre les sections.",
    inbox_complete_before: "Achever pour",
    inbox_invitation: "Invitation",
    inbox_organisation: "Organisation",
    inbox_start: "Vers l'aperçu",
    inbox_no_messages_for_participant: "Il n'y a aucun message",
    inbox_could_not_process_your_request: "Impossible de traiter votre demande",
    inbox_page_title: "Boîte de réception"
};
